import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfWhatInBox, { EfWhatInBoxItemProps } from '@elem/ui/ef-what-in-box';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3Plus');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'uk'].includes(locale ?? '');
    let imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1724664073834/dd2.png';

    if (['uk'].includes(locale)) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1732529485969/uk.png';
    } else if (IS_EU_SITES) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1731924318317/product.png';
    } else if (['au'].includes(locale)) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1736932656168/EcoFlow%20DELTA%203%20Plus.png';
    }

    const list: EfWhatInBoxItemProps[] = [
        {
            title: t('N_text1'),
            pc: imgUrl,
        },
        {
            title: t('N_text2'),
            pc: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1730081358098/AC_cable_eu.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1725500461530/AC_cable_na.png',
        },
        // {
        //     title: t('N_text3'),
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816399/a2.png',
        // },
        // {
        //     title: t('N_text4'),
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816161/a3.png',
        // },
        {
            title: t('N_text5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816618/a4.png',
        },
    ];

    if (IS_EU_SITES && pageStatus !== 'statusB') {
        return null;
    }

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{t('N_title')}</EfTitle>
            <EfWhatInBox list={list} />
            {IS_EU_SITES && pageStatus === 'statusB' && <EfSpec className="spec-x" />}
        </div>
    );
}
